import { Component, ChangeDetectionStrategy } from '@angular/core';
import { FieldTypeConfig, FieldType } from '@ngx-formly/core';

@Component({
  standalone: false,
  selector: "formly-file-select",
  templateUrl: "./file-select.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class FormlyFileSelect extends FieldType<FieldTypeConfig> {

  onChange(value: File[]): void {
    if (this.props.change) {
      this.props.change(this.field, value);
    }
  }

}
